import { render, staticRenderFns } from "./Plugins.vue?vue&type=template&id=6b2ba386&scoped=true"
import script from "./Plugins.vue?vue&type=script&lang=ts"
export * from "./Plugins.vue?vue&type=script&lang=ts"
import style0 from "./Plugins.vue?vue&type=style&index=0&id=6b2ba386&prod&lang=scss&scoped=true"
import style1 from "./Plugins.vue?vue&type=style&index=1&id=6b2ba386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ba386",
  null
  
)

export default component.exports